import { render, staticRenderFns } from "./CreateEventInfo.vue?vue&type=template&id=82c68d66&scoped=true"
import script from "./CreateEventInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEventInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateEventInfo.vue?vue&type=style&index=0&id=82c68d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c68d66",
  null
  
)

export default component.exports